export function AuthSubmitIcon() {
  return (
    <span className="inline-grid shrink-0 grid-cols-2 gap-[3px]" aria-hidden>
      <span className="size-[3px] rounded-[1px] bg-white" />
      <span className="size-[3px] bg-white" />
      <span className="size-[3px] bg-white" />
      <span className="size-[3px] rounded-[1px] bg-white" />
    </span>
  );
}
